<!--
	its frontend

	Page, submodule from App

    @file         Page_liProL_light.svelte
    @author       Robert Fischer, fischer@tForge.eu
    @date         05/2022
    @copyright    tForge
-->


<script>
    import { URL_API, URL_IMG } 	from './minions';

    import {createEventDispatcher}  from "svelte";
    let dispatch =  createEventDispatcher();



// ============================ store variables ==============================

    import { st_login } from './stores';

    let login;
    st_login.subscribe(value => {
        login = value;
    });



// ======================== Analysis steps in Backend ========================

    let imageFilename;
    let imgSrc;

    let busy_calculateDeltaE = false;
    let deltaE_ready = false;
    let deltaE_testPassed = false;
    let data_dE_cmR;
    let data_dE_maxMeasured = 0;
 

    const imageUpload = async ()=> {

        let pa = document.getElementById("imageUploadDOMEl");

        pa.onchange = async evt=> {

            let file = evt.target.files[0];
            if (file) {
                const formImg = new FormData();
                formImg.append('imageFile', file);
                formImg.append('jsonStr', JSON.stringify({...login, flip:true}));

                const reply = await fetch(URL_API("upload_image"), {
                            method:'post',
                            body: formImg
                        })
                    .catch( err=> {
                        console.log('image upload failed')
                    });

                if (reply && reply.ok) {

                    const data = await reply.json();
                    imageFilename = data["imageFilename"];
                    imgSrc = URL_IMG(imageFilename);

                    checkDeltaE();
                }
                else {
                    dispatch('message', {text: "Failed to connect to server."});
                }
            }
        }

        pa.click();

        deltaE_ready = false;

    };//imageUpload()


    const checkDeltaE = async ()=> {

        busy_calculateDeltaE = true;

        const reply = await fetch(URL_API("lipro/check_deltae_light"), {
                method:'post',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    ...login, imageFilename: imageFilename
                }
                )});

        if (reply && reply.ok) {
            const data = await reply.json();
            data_dE_cmR = data.cmScale.data[0].z;

            Plotly.newPlot('plotDeltaE_cmR', data.cmScale);

            deltaE_testPassed = data.testPassed;
            data_dE_maxMeasured = data.maxDE;
            maxScale_dE = data.maxAllowedDeltaE;
            deltaE_ready = true;
        }
        else if (reply){
            const msg = await reply.text();
            if (msg.includes('not square')){
                dispatch('message', {text: "Please use only images of square plates (20 x 20 cm)."});
            }
            else {
                dispatch('message', {text: msg});
            }
        }        
        else {
            dispatch('message', {text: "Failed to check deltaE."});
        }

        busy_calculateDeltaE = false;

    };//checkDeltaE()



// ========================== Interactive y-scaling ==========================


    let maxScale_dE = 10;
 

    const update_maxScale = plotname => {

        let minScale = 0;
        let maxScale = 50;
        if (plotname.includes("plotDeltaE")){
            maxScale = maxScale_dE;
        }
        else {
            return;
        }

        const plotUpdate = {'zmin': minScale, 'zmax': maxScale};
        Plotly.update(plotname + '_cmR', plotUpdate, {}, [0]);

    };//update_maxScale_dE()


    const exportData = plotname => {

        let rows = [];
        if (plotname == "plotDeltaE_cmR"){
            rows = data_dE_cmR;
        }
        else {
            return;
        }
        rows.reverse();

        let csvContent = "data:text/csv;charset=utf-8,";
        rows.forEach(function(rowArray) {
            let row = rowArray.join(", ");
            csvContent += row + "\r\n";
        });

        var encodedUri = encodeURI(csvContent);
        let dl = document.createElement("a");
        dl.setAttribute("href", encodedUri);
        dl.setAttribute("download", `${plotname}.csv`);
        document.body.appendChild(dl); // Required for FF
        dl.click();

    };//exportData()



// ========================== Construction / Init ============================

    import { onMount, onDestroy } 	from 'svelte';


    onMount(async () => {

    });//onMount()


	onDestroy(async () => {

	});//onDestroy()

</script>




<!-- =============================  H T M L  ============================= -->

<div class="page">

    <h1>LiPro Quick Test</h1>

    <h3>Illumination profiles</h3>

    <div class="btn" on:click={imageUpload}>
        Upload an image
    </div>

    <!-- Show uploaded image, incl. marker of regions used for profile analysis -->
    {#if imgSrc}
    <div class="box">
        <img src={imgSrc} alt="">
    </div>
    {/if}


    <!-- deltaE from mean value -->
    {#if busy_calculateDeltaE}
        <h3>... calculating and plotting deltaE value for each pixel, please wait ...</h3>
    {/if}

    <div class="box" class:hide={!deltaE_ready}>
        <div class="plotHeaderRow">
            <div class="btn" on:click={()=> exportData('plotDeltaE_cmR')}>
                Export data
            </div>

            <div class="box-input">
                <label for="maxScale_dE">Scale maximum</label>
                <input id="maxScale_dE_cmR"  class="input-txt"
                    bind:value={maxScale_dE} on:input={()=>update_maxScale('plotDeltaE')}
                    type="number" min="5" max="100" pattern="\d*">
            </div>
        </div>
        <div class="plot" id="plotDeltaE_cmR"></div>


        {#if deltaE_testPassed}
            <div class="msgPass">Test passed (max deltaE: {data_dE_maxMeasured.toFixed(2)})</div>
        {:else}
            <div class="msgPass msgFail">Test failed (max deltaE: {data_dE_maxMeasured.toFixed(2)})</div>
        {/if}
    </div>

</div>

<input id="imageUploadDOMEl" name="imageFile" type="file" accept="image/jpeg"  style="display:none;"/>






<!-- ============================  S T Y L E  ============================ -->



<style>
	.page {
        width: 100%;
        max-width: 1400px;
        margin-top: 2em;
        margin-left: auto;
        margin-right: auto;
        padding: 2em;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    h1 {
        margin-top: 3em;
    }

    h3 {
        border-top: 1px solid var(--tF-gray);
        padding: 1em 2em;
        margin: 1em auto;
    }
    .btn {
        width: 20em;
    }

    .box {
        margin-top: 3em;
        width: 90%;
        max-width: 1400px;
    }

    .box img{
        width: 50%;
        max-width: 1200px;
        object-fit: contain;
    }

    .plot {
        width: 100%;
        min-height: 800px;
        overflow: hidden;
        margin-bottom: 3em;
        margin-left: 0px;
    }

    .plotHeaderRow {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-bottom: 0.5em;
        align-items: flex-end;
    }

    .msgPass {
        width: 100%;
        padding: 3em;
        background-color: darkgreen;
        color: white;
        font-size: 1.5em;
    }
    .msgFail {
        background-color: darkred;
    }

</style>